// extracted by mini-css-extract-plugin
export default {"container":"TeamMemberDetails_container__noYRF"};